import { ReactNode } from "react";

import PostHogAnalyticsProvider from "common/contexts/PostHogAnalyticsProvider";

import { INITIAL_CLIENT_DATA } from "client/common/utils";

// Must match marketing.constants.POSTHOG_CLIENT_DISTINCT_ID_PREFIX.
const CLIENT_POSTHOG_DISTINCT_ID_PREFIX = "client_";

const { user } = INITIAL_CLIENT_DATA;
const CLIENT_POSTHOG_IDENTITY = user
  ? {
      uniqueId: `${CLIENT_POSTHOG_DISTINCT_ID_PREFIX}${user.client_id}`,
      email: user.email,
      phoneNumber: user.phone_number,
      firstName: user.first_name,
      lastName: user.last_name,
    }
  : null;

type ClientAnalyticsProviderProps = {
  children: ReactNode;
};

const ClientAnalyticsProvider = ({ children }: ClientAnalyticsProviderProps) => {
  return (
    <PostHogAnalyticsProvider
      identity={CLIENT_POSTHOG_IDENTITY}
      isEnabled={INITIAL_CLIENT_DATA.has_internal_analytics_tracking}
    >
      {children}
    </PostHogAnalyticsProvider>
  );
};

export default ClientAnalyticsProvider;
